import Joi from "joi";
export const addShippingSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        containerNumber: Joi.string().allow(null, "", NaN).optional().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.containerNumber.invalid,
            "string.min": joiMessage.shipping_modal.containerNumber.min,
            "string.max": joiMessage.shipping_modal.containerNumber.max,
        }),
        trackingId: Joi.string().allow(null, "", NaN).optional().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.trackingId.invalid,
            "string.min": joiMessage.shipping_modal.trackingId.min,
            "string.max": joiMessage.shipping_modal.trackingId.max,
        }),
        containerCapacity: Joi.number().positive()
            .allow(0)
            .required()
            .messages({
                "number.base": joiMessage.shipping_modal.containerCapacity.invalid,
                "number.positive": joiMessage.shipping_modal.containerCapacity.positive,
                "number.empty": joiMessage.shipping_modal.containerCapacity.required
            }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipping_modal.NB.invalid,
            "string.max": joiMessage.shipping_modal.NB.max,
        })
    };
    return schema;
};

export const updateShippingSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        containerNumber: Joi.string().allow(null, "", NaN).optional().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.containerNumber.invalid,
            "string.min": joiMessage.shipping_modal.containerNumber.min,
            "string.max": joiMessage.shipping_modal.containerNumber.max,
        }),
        trackingId: Joi.string().allow(null, "", NaN).optional().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.trackingId.invalid,
            "string.min": joiMessage.shipping_modal.trackingId.min,
            "string.max": joiMessage.shipping_modal.trackingId.max,
        }),
        containerCapacity: Joi.number().positive()
            .allow(0)
            .optional()
            .messages({
                "number.base": joiMessage.shipping_modal.containerCapacity.invalid,
                "number.positive": joiMessage.shipping_modal.containerCapacity.positive,
                "number.empty": joiMessage.shipping_modal.containerCapacity.required
            }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipping_modal.NB.invalid,
            "string.max": joiMessage.shipping_modal.NB.max,
        })
    };
    return schema;
};


export const addShippingCostSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        onName: Joi.string().required().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.addShippingCost.onName.invalid,
            "string.min": joiMessage.shipping_modal.addShippingCost.onName.min,
            "string.max": joiMessage.shipping_modal.addShippingCost.onName.max,
            "string.empty": joiMessage.shipping_modal.addShippingCost.onName.empty
        }),
        phoneNumber: Joi.string().allow("").optional().max(100).messages({
            "string.base": joiMessage.shipping_modal.addShippingCost.phoneNumber.invalid,
            "string.max": joiMessage.shipping_modal.addShippingCost.phoneNumber.max
        }),
        costAmount: Joi.number().positive()
            .required()
            .messages({
                "number.base": joiMessage.shipping_modal.addShippingCost.costAmount.invalid,
                "number.positive": joiMessage.shipping_modal.addShippingCost.costAmount.positive,
                "number.empty": joiMessage.shipping_modal.addShippingCost.costAmount.empty
            }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipping_modal.NB.invalid,
            "string.max": joiMessage.shipping_modal.NB.max,
        })
    };
    return schema;
};
export const editShippingCostSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        onName: Joi.string().optional().min(1).max(100).messages({
            "string.base": joiMessage.shipping_modal.addShippingCost.onName.invalid,
            "string.min": joiMessage.shipping_modal.addShippingCost.onName.min,
            "string.max": joiMessage.shipping_modal.addShippingCost.onName.max,
            "string.empty": joiMessage.shipping_modal.addShippingCost.onName.empty
        }),
        phoneNumber: Joi.string().allow("").optional().max(100).messages({
            "string.base": joiMessage.shipping_modal.addShippingCost.phoneNumber.invalid,
            "string.max": joiMessage.shipping_modal.addShippingCost.phoneNumber.max
        }),
        costAmount: Joi.number().positive()
            .optional()
            .messages({
                "number.base": joiMessage.shipping_modal.addShippingCost.costAmount.invalid,
                "number.positive": joiMessage.shipping_modal.addShippingCost.costAmount.positive,
            }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipping_modal.NB.invalid,
            "string.max": joiMessage.shipping_modal.NB.max,
        })
    };
    return schema;
};